export * from './info.component';
